'use client'

import MapboxMarkerBase from '../baseMarker'
import IconMarker from '@icon/const/map-marker.svg'

export default function MapboxCenterMarker({
  lng,
  lat,
  children
}) {

  return (
    <MapboxMarkerBase lng={lng} lat={lat}>
      {
        children
          ? children
          : (
            <IconMarker width={40} height={40} className='block -translate-y-1/2' />
          )
      }
    </MapboxMarkerBase>
  )
}
